import React from "react";
import {SearchQuicklinks} from "../types/searchQuicklinks";
import {decode} from 'html-entities';
import {useTranslation} from "../hooks/useTranslation";

type QuicklinksProps = {
    searchQuicklinks: SearchQuicklinks[]
}

export function Quicklinks({searchQuicklinks}: QuicklinksProps) {

    const translate = useTranslation();

    return (
        <div className='search__quicklinks col-12 col-lg-4'>
            <div className='search__quicklinks--title'>{translate('search.quicklinks.title')}</div>

            <ul className='search__quicklinks--list'>
                {searchQuicklinks
                    .map((link, index) =>
                        <li key={index}>
                            <a href={link.url} >{decode(link.text)}</a>
                        </li>
                    )}
            </ul>
        </div>
    )
}